import React from 'react'
import { BsInfoCircleFill } from "react-icons/bs";
import { Tooltip } from 'antd';
import Helptext from "./Helptexts.json"

type HelptextKeys = keyof typeof Helptext;

interface HelpTextProps {
  tooltipkey: HelptextKeys;
}
const HelpText = (props: HelpTextProps) => {

  return (
        <Tooltip title={<div dangerouslySetInnerHTML={{__html: Helptext[props.tooltipkey]}} />} >
        <BsInfoCircleFill  size={10} fill="#A47FF1" />
        </Tooltip>    
  )
}

export default HelpText;